import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ReadonlyText } from "./GlobalAdminOrganizationFormBase.styles";
import { HXTextField } from "../base.styles";
export const EditableText = (props) => {
    const { editable, ...textFieldProps } = props;
    if (editable) {
        return _jsx(HXTextField, { ...textFieldProps });
    }
    else {
        return _jsx(ReadonlyText, { children: String(props.value) });
    }
};
